export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user',
    AGENCY: 'agency',
    ACCOUNT: 'account',
};
export var AttributionMediums;
(function (AttributionMediums) {
    AttributionMediums["Conversation"] = "conversation";
    AttributionMediums["Manual"] = "manual";
})(AttributionMediums || (AttributionMediums = {}));
export var AttributionSource;
(function (AttributionSource) {
    AttributionSource["Others"] = "Others";
    AttributionSource["CrmUI"] = "CRM UI";
})(AttributionSource || (AttributionSource = {}));
export const NEW_MESSAGE_FLOW_CONVERSATION_ID = 'new-contact-conversation';
